import React from 'react';
import ErrorPage from './ErrorPage';

const AccessUnauthorizedPage = () => {
    return (
        <ErrorPage className='access-unauthorized-page'>
            We’re sorry, but it appears that you do not have the necessary authorization to access this page. It seems
            that your Traece account is currently inactive.
        </ErrorPage>
    );
};

export default AccessUnauthorizedPage;


// WEBPACK FOOTER //
// ./src/containers/template/AccessUnauthorizedPage.js